import { Actions, helper } from '@appbaseio/reactivecore';
import { a as _extends } from './_rollupPluginBabelHelpers-0f24d612.js';
import VueTypes from 'vue-types';
import '@appbaseio/reactivecore/lib/utils/constants';
import 'emotion';
import '@appbaseio/vue-emotion';
import 'polished';
import { f as filters, B as Button } from './Button-91561391.js';
import { t as types } from './vueTypes-e89c8a3c.js';
import 'redux';
import { c as connect } from './index-cb1950b6.js';
import { T as Title } from './Title-3522ff56.js';
import { C as Container } from './Container-18b03fde.js';

var setValue = Actions.setValue,
    clearValues = Actions.clearValues,
    resetValuesToDefault = Actions.resetValuesToDefault;
var getClassName = helper.getClassName,
    handleA11yAction = helper.handleA11yAction;
var SelectedFilters = {
  name: 'SelectedFilters',
  props: {
    className: VueTypes.string.def(''),
    clearAllLabel: VueTypes.string.def('Clear All'),
    innerClass: types.style,
    showClearAll: VueTypes.bool.def(true),
    title: types.title,
    resetToDefault: VueTypes.bool.def(false)
  },
  inject: {
    theme: {
      from: 'theme_reactivesearch'
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];

    if (this.$scopedSlots["default"]) {
      return this.$scopedSlots["default"]({
        components: this.components,
        selectedValues: this.selectedValues,
        clearValues: this.clearValues,
        setValue: this.setValue,
        resetValuesToDefault: this.resetValuesToDefault
      });
    }

    var filtersToRender = this.renderFilters();
    var hasValues = !!filtersToRender.length;
    return h(Container, {
      "class": filters(this.theme) + " " + (this.$props.className || '')
    }, [this.$props.title && hasValues && h(Title, {
      "class": getClassName(this.$props.innerClass, 'title') || ''
    }, [this.$props.title]), filtersToRender, this.$props.showClearAll && hasValues ? h(Button, {
      "class": getClassName(this.$props.innerClass, 'button') || '',
      "on": _extends({}, {
        click: this.clearValues,
        keypress: function keypress(event) {
          return handleA11yAction(event, function () {
            return _this.clearValues();
          });
        }
      }),
      "attrs": {
        "tabIndex": "0"
      }
    }, [this.$props.clearAllLabel]) : null]);
  },
  methods: {
    remove: function remove(component, value) {
      if (value === void 0) {
        value = null;
      }

      this.setValue(component, null);
      this.$emit('clear', component, value);
    },
    clearValues: function clearValues() {
      var resetToDefault = this.resetToDefault;

      if (resetToDefault) {
        this.resetValuesToDefault();
      } else {
        this.clearValuesAction();
      }

      this.$emit('clear', null);
    },
    renderValue: function renderValue(value, isArray) {
      var _this2 = this;

      if (isArray && value.length) {
        var arrayToRender = value.map(function (item) {
          return _this2.renderValue(item);
        });
        return arrayToRender.join(', ');
      }

      if (value && typeof value === 'object') {
        // TODO: support for NestedList
        var label = (typeof value.label === 'string' ? value.label : value.value) || value.key || value.distance || null;

        if (value.location) {
          label = value.location + " - " + label;
        }

        return label;
      }

      return value;
    },
    renderFilters: function renderFilters() {
      var _this3 = this;

      var h = this.$createElement;
      var selectedValues = this.selectedValues;
      return Object.keys(selectedValues).filter(function (id) {
        return _this3.components.includes(id) && selectedValues[id].showFilter;
      }).map(function (component, index) {
        var _selectedValues$compo = selectedValues[component],
            label = _selectedValues$compo.label,
            value = _selectedValues$compo.value;
        var isArray = Array.isArray(value);

        if (label && (isArray && value.length || !isArray && value)) {
          var valueToRender = _this3.renderValue(value, isArray);

          return h(Button, {
            "class": getClassName(_this3.$props.innerClass, 'button') || '',
            "key": component + "-" + (index + 1),
            "on": _extends({}, {
              click: function click() {
                return _this3.remove(component, value);
              },
              keypress: function keypress(event) {
                return handleA11yAction(event, function () {
                  return _this3.remove(component, value);
                });
              }
            }),
            "attrs": {
              "tabIndex": "0"
            }
          }, [h("span", [selectedValues[component].label, ": ", valueToRender]), h("span", ["\u2715"])]);
        }

        return null;
      }).filter(Boolean);
    }
  },
  watch: {
    selectedValues: function selectedValues(newVal) {
      this.$emit('change', newVal);
    }
  }
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    components: state.components,
    selectedValues: state.selectedValues
  };
};

var mapDispatchtoProps = {
  clearValuesAction: clearValues,
  setValue: setValue,
  resetValuesToDefault: resetValuesToDefault
};
var RcConnected = connect(mapStateToProps, mapDispatchtoProps)(SelectedFilters);

SelectedFilters.install = function (Vue) {
  Vue.component(SelectedFilters.name, RcConnected);
};

export default SelectedFilters;
